import { Button, CommonModalProps, useRespondToRange } from "@animech/ui";
import { FunctionComponent, HTMLAttributes, useMemo } from "react";
import { ArticleTable } from "../../widgets/article-table/article-table";
import * as Styled from "./cart-modal.style";
import {
	ArticleList,
	CartButton,
	ListIcon,
	useCartPricing,
	useUiData,
} from "src/ui";
import { PrintButton } from "src/ui/components/widgets/print-button/print-button";

export type CartModalProps = CommonModalProps<HTMLAttributes<HTMLDivElement>>;

export const CartModal: FunctionComponent<CartModalProps> = (baseProps) => {
	const { localizer } = useUiData();
	const isTabletUp = useRespondToRange("tablet", "up");

	const footerButtons = useMemo(
		() => [
			<CartButton key="send-to-cart" />,
			<PrintButton key="print-button" />,
		],
		[],
	);

	return (
		<Styled.CartModalBase
			icon={<ListIcon />}
			title={localizer.localizeTerm("cartSummaryTitle")}
			footerButtons={footerButtons}
			hideCloseButton={!isTabletUp}
			{...baseProps}
		>
			<Styled.CartModalContent>
				{isTabletUp ? (
					<DesktopContent />
				) : (
					<MobileContent
						onClose={() => baseProps.onShouldClose && baseProps.onShouldClose()}
					/>
				)}
			</Styled.CartModalContent>
		</Styled.CartModalBase>
	);
};

const TotalPrice: FunctionComponent = () => {
	const { localizer } = useUiData();
	const { formattedTotalPrice } = useCartPricing();
	return (
		<Styled.TotalPrice>
			{localizer.localizeTerm("totalPrice")} {formattedTotalPrice}
		</Styled.TotalPrice>
	);
};

const DesktopContent: FunctionComponent = () => {
	const { priceSummaryDescription } = useCartPricing();
	return (
		<>
			<ArticleTable />
			<TotalPrice />
			<Styled.PriceDisclaimer>{priceSummaryDescription}</Styled.PriceDisclaimer>
		</>
	);
};

const MobileContent: FunctionComponent<{ onClose: () => void }> = ({
	onClose,
}) => {
	const { localizer } = useUiData();
	const { priceSummaryDescription } = useCartPricing();
	return (
		<>
			<Styled.MobileHeader>
				<Styled.MobileTitle>
					<ListIcon />
					<p>{localizer.localizeTerm("cartSummaryTitle")}</p>
				</Styled.MobileTitle>
				<Button
					icon="close-thin"
					onClick={onClose}
					rounded
					appearance="text"
				></Button>
			</Styled.MobileHeader>
			<ArticleList />
			<Styled.FooterNote>
				<TotalPrice />
				<Styled.PriceDisclaimer>
					{priceSummaryDescription}
				</Styled.PriceDisclaimer>
			</Styled.FooterNote>
		</>
	);
};
